<template><section><h2>Legend</h2>
<p>当实例化 <code v-pre>chart</code> 后，向 <code v-pre>chart</code> 添加 <code v-pre>Legend</code> 插件即可，<code v-pre>chart.append(new Legend())</code>。</p>
<block-demo tip="" source="const data = [{ value: 2010 }, { value: 2011 }, { value: 2012 }]
const { Chart, Legend } = qcharts

const chart = new Chart({ container: &#39;#app&#39; })
chart.source(data, {
  value: &#39;value&#39;
})

const l1 = new Legend({ orient: &#39;vertical&#39;, align: [&#39;left&#39;, &#39;top&#39;] })
const l2 = new Legend({ orient: &#39;vertical&#39;, align: [&#39;left&#39;, &#39;bottom&#39;] })
const l3 = new Legend({ orient: &#39;vertical&#39;, align: [&#39;center&#39;, &#39;center&#39;] })
const l4 = new Legend({ orient: &#39;vertical&#39;, align: [&#39;right&#39;, &#39;top&#39;] })
const l5 = new Legend({ orient: &#39;vertical&#39;, align: [&#39;right&#39;, &#39;bottom&#39;] })

chart.append([l1, l2, l3, l4, l5])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [{ <span class="hljs-attr">value</span>: <span class="hljs-number">2010</span> }, { <span class="hljs-attr">value</span>: <span class="hljs-number">2011</span> }, { <span class="hljs-attr">value</span>: <span class="hljs-number">2012</span> }]
<span class="hljs-keyword">const</span> { Chart, Legend } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({ <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span> })
chart.source(data, {
  <span class="hljs-attr">value</span>: <span class="hljs-string">'value'</span>
})

<span class="hljs-keyword">const</span> l1 = <span class="hljs-keyword">new</span> Legend({ <span class="hljs-attr">orient</span>: <span class="hljs-string">'vertical'</span>, <span class="hljs-attr">align</span>: [<span class="hljs-string">'left'</span>, <span class="hljs-string">'top'</span>] })
<span class="hljs-keyword">const</span> l2 = <span class="hljs-keyword">new</span> Legend({ <span class="hljs-attr">orient</span>: <span class="hljs-string">'vertical'</span>, <span class="hljs-attr">align</span>: [<span class="hljs-string">'left'</span>, <span class="hljs-string">'bottom'</span>] })
<span class="hljs-keyword">const</span> l3 = <span class="hljs-keyword">new</span> Legend({ <span class="hljs-attr">orient</span>: <span class="hljs-string">'vertical'</span>, <span class="hljs-attr">align</span>: [<span class="hljs-string">'center'</span>, <span class="hljs-string">'center'</span>] })
<span class="hljs-keyword">const</span> l4 = <span class="hljs-keyword">new</span> Legend({ <span class="hljs-attr">orient</span>: <span class="hljs-string">'vertical'</span>, <span class="hljs-attr">align</span>: [<span class="hljs-string">'right'</span>, <span class="hljs-string">'top'</span>] })
<span class="hljs-keyword">const</span> l5 = <span class="hljs-keyword">new</span> Legend({ <span class="hljs-attr">orient</span>: <span class="hljs-string">'vertical'</span>, <span class="hljs-attr">align</span>: [<span class="hljs-string">'right'</span>, <span class="hljs-string">'bottom'</span>] })

chart.append([l1, l2, l3, l4, l5])
</code></pre>
</block-demo><h3>属性</h3>
<table>
<thead>
<tr>
<th>属性名</th>
<th>类型</th>
<th>默认值</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td><code v-pre>orient</code></td>
<td>String</td>
<td>'horizontal'</td>
<td>legend 排列方式，默认水平排列，可取值：<code v-pre>horizontal</code> 、 <code v-pre>vertical</code></td>
</tr>
<tr>
<td><code v-pre>align</code></td>
<td>Array</td>
<td><code v-pre>['left', 'top']</code></td>
<td>legend 绘制位置，默认靠左靠顶</td>
</tr>
<tr>
<td><code v-pre>formatter</code></td>
<td>Function</td>
<td><code v-pre>d =&gt; d.value || d</code></td>
<td>legend 文本格式化函数</td>
</tr>
</tbody>
</table>
</section></template><script>export default {components:{}}</script>